import * as React from "react";
const SvgDragHorizontal20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4.167 5.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm5.833 0a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm5.834 0a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666Zm-11.667 6a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667Zm5.833 0a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667Zm5.834 0a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667Z",
      clipRule: "evenodd"
    })
  );
export default SvgDragHorizontal20Px;
